// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__36PWq","onOpen":"Header_onOpen__3inAI","buttonToggle":"Header_buttonToggle__3LmNQ","dark":"Header_dark__geoX5"};